export default __webpack_public_path__ + "static/media/right-arrow-angle.dae5f0ad.png";